import React, { Fragment } from 'react'
import { Link, withRouter } from "react-router-dom"
import { signout, isAuthenticated } from "../auth/helper/adminIndex"
import { pisAuthenticated } from "../auth/helper/partnerIndex"
import { disAuthenticated } from "../auth/helper/driverIndex"
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { FaTruck } from 'react-icons/fa'
import './Navbar.css'

const isActive = (history, path) =>
    history.location.pathname === path ? 'ttms-nav-link active-link' : 'ttms-nav-link';

const MyNavbar = ({ history }) => (
    <Navbar className="ttms-navbar" expand="lg">
        <Navbar.Brand href="/" className="ttms-brand">
            <FaTruck className="ttms-brand-icon" />
            TTMS
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="ttms-navbar-nav" />
        <Navbar.Collapse id="ttms-navbar-nav">
            <Nav className="mr-auto">
                <Link className={isActive(history, "/")} to="/">
                    Home
                </Link>

                {isAuthenticated() && isAuthenticated().admin && (
                    <Link className={isActive(history, "/admin/dashboard")} to="/admin/dashboard">
                        Admin Dashboard
                    </Link>
                )}

                {pisAuthenticated() && pisAuthenticated().partner && (
                    <Link className={isActive(history, "/partner/dashboard")} to="/partner/dashboard">
                        Customer Dashboard
                    </Link>
                )}

                {disAuthenticated() && disAuthenticated().driver && (
                    <Link className={isActive(history, "/driver/dashboard")} to="/driver/dashboard">
                        Driver Dashboard
                    </Link>
                )}

                {!isAuthenticated() && !pisAuthenticated() && !disAuthenticated() && (
                    <Fragment>
                        <NavDropdown
                            title="Admin"
                            id="admin-nav-dropdown"
                            className="ttms-dropdown"
                        >
                            <Link className="ttms-dropdown-item" to="/adminsignin">
                                Admin Signin
                            </Link>
                        </NavDropdown>

                        <NavDropdown
                            title="Driver"
                            id="driver-nav-dropdown"
                            className="ttms-dropdown"
                        >
                            <Link className="ttms-dropdown-item" to="/driverSignin">
                                Driver Signin
                            </Link>
                        </NavDropdown>

                        <NavDropdown
                            title="Customer"
                            id="customer-nav-dropdown"
                            className="ttms-dropdown"
                        >
                            <Link className="ttms-dropdown-item" to="/partnerSignin">
                                Customer Signin
                            </Link>
                        </NavDropdown>
                    </Fragment>
                )}

                {(isAuthenticated().admin || pisAuthenticated().partner || disAuthenticated().driver) && (
                    <span
                        className="ttms-signout"
                        onClick={() => {
                            signout(() => {
                                history.push("/")
                            })
                        }}
                    >
                        Signout
                    </span>
                )}
            </Nav>
        </Navbar.Collapse>
    </Navbar>
)

export default withRouter(MyNavbar);
